export function findKeyPaths(root, query) {
  const needle = query.trim().toLocaleLowerCase();
  if (!needle) return [];

  const matches = [];
  visit(root, [], '', needle, matches);
  return matches;
}

function visit(value, segments, displayPath, needle, output) {
  if (Array.isArray(value)) {
    value.forEach((item, index) => {
      const segment = String(index);
      visit(item, [...segments, segment], appendSimple(displayPath, segment), needle, output);
    });
    return;
  }

  if (value === null || typeof value !== 'object') return;

  for (const [key, child] of Object.entries(value)) {
    const childSegments = [...segments, key];
    const childPath = appendKey(displayPath, key);
    if (key.toLocaleLowerCase().includes(needle)) {
      output.push({ key, path: childPath, segments: childSegments, value: child });
    }
    visit(child, childSegments, childPath, needle, output);
  }
}

function appendKey(parent, key) {
  if (/^[A-Za-z_$][\w$]*$/.test(key) || /^\d+$/.test(key)) {
    return appendSimple(parent, key);
  }
  return `${parent}[${JSON.stringify(key)}]`;
}

function appendSimple(parent, segment) {
  return parent ? `${parent}.${segment}` : segment;
}
